import persist from './persist'
import axios from 'axios'
// import { NotUnique } from '../errors/bucketErrors'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
    accounts: [],
    signupData: {},
    signupRowkey: '',
    signupSuccess: false,
  },
  mutations: {
    RESET_SIGNUP (state) {
      state.signupData = {}
      state.signupRowkey = ''
    },
    SAVE_SIGNUP (state, data) {
      state.signupData = data
    },
    SAVE_SIGNUPROWKEY (state, data) {
      state.signupRowkey = data
    },
  },
  actions: {
    // Customer Accounts
    async submitSignup ({ state, commit, dispatch }, payload) {
      try {
        commit('SAVE_SIGNUP', payload)
        const params = {
          form_data: payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/entrance/contract-signup`, params)
        commit('SAVE_SIGNUPROWKEY', data.rowkey)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async updateSignup ({ state, commit, dispatch }, payload) {
      try {
        const params = {
          form_data: payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/entrance/contract-signup`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async resetSignup ({ commit }) {
      commit('RESET_SIGNUP')
    },
    async getSignup ({ state, commit, dispatch }, payload) {
      try {
        const params = {
          form_data: payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/signup/`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getMobileVerificationCode ({ state, commit, dispatch }, payload) {
      try {
        const params = {
          contact: payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/sms/send-sms-code`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getEmailVerificationCode ({ state, commit, dispatch }, payload) {
      try {
        const params = {
          contact: payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/email/send-code`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async verifyEmail ({ state, commit, dispatch }, payload) {
      try {
        const params = { ...payload }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/email/verify-code`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async verifyMobile ({ state, commit, dispatch }, payload) {
      try {
        const params = { ...payload }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/sms/verify-code`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getAvailablePlans ({ state, commit, dispatch }, payload) {
      try {
        const params = {
          ...payload,
        }
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/entrance/plans/get-available-plans`, params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async registerUser ({ dispatch, commit, rootState }, payload) {
      try {
        console.log('Registering user... ', payload)
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/entrance/register-user`, payload)
        console.log(data)
        await dispatch('login', payload)
        // commit('LOGIN', response.data)
      } catch (error) {
        const processedError = await dispatch('processAxiosError', error)
        console.log(processedError)
        return []
      }
    },
    async verifyUniqueEmail ({ dispatch, commit, rootState }, payload) {
      try {
        console.log('Verifying unique email... ', payload)
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/entrance/verify-unique-email`, { params: payload })
        return data
        // commit('LOGIN', response.data)
      } catch (e) {
        console.log(e)
        return false
      }
    },

  },
  getters: {
    signupData: state => state.signupData,
    signupRowkey: state => state.signupRowkey,

  },
  plugins: [persist.plugin],
}
